import * as PIXI from "pixi.js";
import Game from "../Game";

import { getPolygonConDeltail } from "../types/config";

export default class PolygonCon extends PIXI.Graphics {
  Game: Game;
  constructor() {
    super();
    this.Game = Game.getInstance();
    const { x, y, width, height, radius } = getPolygonConDeltail(this.Game.getDim());
    this.roundRect(x, y, width, height, radius)
      .stroke({
        color: 0x000000,
        width: 3
      })
    this.Game.bottomContainer.addChild(this);
  }
}